import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ReservationService } from '../../reservation.service';
import { ReportService } from '@app/_components/report';

@Component({
    selector: 'app-reservation-advance-search.component',
    templateUrl: './reservation-advance-search.component.html',
    styleUrls: ['./reservation-advance-search.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ReservationAdvanceSearchComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private alertService: AlertService,
		private formBuilder: UntypedFormBuilder,
		private constantService: ConstantService,
		private reportService: ReportService,
		private reservationService: ReservationService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.advanceSearchData = data.advanceSearchData,
		this.locations = this.constantService.locations;
		this.reservationStatuses = this.reservationService.reservationStatuses;
		this.reservationTypes = this.reservationService.reservationTypes;
	}
	
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doSearchCB = new EventEmitter<any>();

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	advanceSearchData = [];

	statuses: any;
	locations: any[];
	minArrivalToDate: any = new Date();
	minSaleToDate: any = new Date();
	minCheckoutToDate: any = new Date();
	minOccupyingToDate: any = new Date();
	reservationStatuses: any[]=[];
	reservationTypes: any[];
	shortTermRentals: any;

	validationMessages = {
		'locationIds': [],
		'arrivalStartDate': [],
		'arrivalEndDate': [],
		'saleStartDate': [],
		'saleEndDate': [],
		'checkoutStartDate': [],
		'checkoutEndDate': [],
		'occupyingStartDate': [],
		'occupyingEndDate': [],
		'reservationStatus': [],
		'reservationType': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.loadShortTermRentals();
		this.formBuild();

		// if we were passed the whole advanceSearchData object
		if (this.advanceSearchData) {
			this.form1.patchValue(this.advanceSearchData);
		}
	}

	formSubmit() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.doSearchCB.emit(this.form1.value);
		} catch (error) {
			this.alertService.error(error);
		}
	}

	clearForm() {
		this.form1.reset();
		this.minArrivalToDate = new Date();
		this.minSaleToDate = new Date();
		this.minCheckoutToDate = new Date();
		this.minOccupyingToDate = new Date();
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			locationIds: [],
			arrivalStartDate: [],
			arrivalEndDate: [],
			saleStartDate: [],
			saleEndDate: [],
			checkoutStartDate: [],
			checkoutEndDate: [],
			occupyingStartDate: [],
			occupyingEndDate: [],
			reservationStatus: [],
			reservationType:[],
			lastName: [],
			emailAddress: [],
			wildcardSearch: [],
			shortTermRentalIds:[],
		});
	}

	onDateChange()
	{
		// start date
		if (this.form1.get('arrivalStartDate').value) {
			this.minArrivalToDate = this.form1.get('arrivalStartDate').value;
		}
		if (this.form1.get('saleStartDate').value) {
			this.minSaleToDate = this.form1.get('saleStartDate').value;
		}
		if (this.form1.get('checkoutStartDate').value) {
			this.minCheckoutToDate = this.form1.get('checkoutStartDate').value;
		}
		if (this.form1.get('occupyingStartDate').value) {
			this.minOccupyingToDate = this.form1.get('occupyingStartDate').value;
		}
	}

	loadShortTermRentals() {
			this.formLoading = true;
			this.reportService.propertySummaryList().pipe().subscribe(
	
				data => {
					this.shortTermRentals = data.data.propertySummaryList;
				},
				error => {
					console.log('reports LIST!: ' + JSON.stringify(error));
				},
				() => { this.formLoading = false; }
			);
		}
}
